import rootReducer from '../reducers/index';
import thunkMiddleware from 'redux-thunk';
import logger from './logger';
import {composeWithDevTools} from 'redux-devtools-extension';
import monitorReducerEnhancer from './monitor-reducer';
import { compose, createStore, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import { sessionService } from 'redux-react-session';

/*const actionSanitizer = (action) => (
	action.type === 'FILE_DOWNLOAD_SUCCESS' && action.data ?
		{ ...action, data: '<<LONG_BLOB>>' } : action
);

const googleExtension = (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION__) ? window.__REDUX_DEVTOOLS_EXTENSION__({
	actionSanitizer,
	stateSanitizer: (state) => state.data ? { ...state, data: '<<LONG_BLOB>>' } : state,
	serialize: true
}) : null;*/

const middlewareEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware/*, logger*/));

const configureStore = compose(
	middlewareEnhancer,
	monitorReducerEnhancer
)(createStore);

const store = configureStore(rootReducer);

export const history = createBrowserHistory();

export const location = history.location;

sessionService.initSessionService(store);

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js